// Resolve a relative API path to a fetchable URL.
//
// Dev: VITE_API_BASE_URL is unset, returns '/api/...' which Vite proxies
//      to the local Mission Control backend (see vite.config.ts).
// Prod: VITE_API_BASE_URL is the absolute API origin
//      (https://ops-api.getpowermove.com), so '/api/...' becomes a
//      cross-origin fetch to the deployed backend.

export function apiPath(path: string): string {
  const base = import.meta.env.VITE_API_BASE_URL ?? '';
  return `${base}${path}`;
}
